import React from 'react';
import {
  Box,
  Typography,
  Divider,
  Paper,
  Fade,
} from '@mui/material';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';

interface ResponseRendererProps {
  response: string;
  copied: boolean;
  onCopy: () => void;
  showEditor?: boolean;
  appointmentId?: string;
}

export const ResponseRenderer: React.FC<ResponseRendererProps> = ({
  response,
  copied,
  onCopy,
  showEditor = false,
  appointmentId
}) => {
  if (!response || showEditor) return null;

  return (
    <Fade in={!!response} timeout={500}>
      <Paper elevation={3} sx={{
        mt: 2,
        p: 2.5,
        bgcolor: '#f5fafd',
        borderLeft: '3px solid #00ae9a',
        borderRadius: 4,
        position: 'relative',
        maxHeight: '40vh',
        overflow: 'auto',
      
        transition: 'box-shadow 0.2s',
      }}>
        <Divider sx={{ mb: 1 }} />
        <Box sx={{ fontSize: 15 }}>
          <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            rehypePlugins={[rehypeRaw]}
            components={{
              code: ({ className, children }) => {
                const isInlineCode = !className;
                return isInlineCode ? (
                  <code style={{
                    backgroundColor: 'rgba(0, 0, 0, 0.05)',
                    padding: '2px 4px',
                    borderRadius: 4,
                    fontSize: '0.95em',
                  }}>
                    {children}
                  </code>
                ) : (
                  <pre style={{
                    backgroundColor: '#2b2b2b',
                    color: '#fff',
                    padding: '12px',
                    borderRadius: 8,
                    overflow: 'auto',
                    fontSize: '0.95em',
                  }}>
                    <code className={className}>
                      {children}
                    </code>
                  </pre>
                );
              },
              a: ({ node, ...props }) => (
                <a
                  {...props}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: '#0277bd',
                    textDecoration: 'none',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.textDecoration = 'underline';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.textDecoration = 'none';
                  }}
                />
              )
            }}
          >
            {response}
          </ReactMarkdown>
        </Box>
      </Paper>
    </Fade>
  );
}; 